(function () {
  'use strict';
  function normalize(value) { return String(value || '').trim().toLowerCase(); }
  function aliases(value) { return String(value || '').split('|').map(normalize).filter(Boolean); }
  function parseTable(text) {
    var lines = String(text || '').trim().split(/\r?\n/).filter(function (line) { return line.trim(); });
    var table = lines.map(function (line) { return line.split(line.includes('\t') ? '\t' : '|').map(function (cell) { return cell.trim(); }); });
    if (table.length < 2 || table[0].length < 2 || table.some(function (line) { return line.length !== table[0].length || line.some(function (cell) { return !cell; }); })) return [];
    return table;
  }
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var config = JSON.parse(root.querySelector('[data-size-guide-config]').textContent);
    var section = root.closest('.shopify-section');
    var selectors = section && section.querySelector('.product-info .product-selectors');
    if (!selectors) return;
    var styleIndex = config.options.findIndex(function (option) { return normalize(option.name) === 'style'; });
    var sizeIndex = config.options.findIndex(function (option) { return normalize(option.name) === 'size'; });
    if (sizeIndex < 0) return;
    var styles = styleIndex >= 0 ? config.options[styleIndex].values.map(normalize) : [];
    var charts = config.charts.filter(function (chart) {
      if (!parseTable(chart.measurements).length) return false;
      if (config.override) return normalize(chart.key) === normalize(config.override);
      return styles.length ? aliases(chart.styles).some(function (style) { return styles.includes(style); }) : aliases(chart.product_types).includes(normalize(config.type));
    });
    if (!charts.length) return;
    var size = selectors.querySelector('.product-swatch--size') || selectors.querySelector('.js-product-option-selector-' + (sizeIndex + 1));
    if (!size) return;
    var heading = size.querySelector('.product-heading');
    var row = size.querySelector('.product-size-heading');
    if (!row) {
      row = document.createElement('div'); row.className = 'product-size-heading'; heading.before(row); row.appendChild(heading);
      var links = document.createElement('div'); links.className = 'product-size-links'; row.appendChild(links);
    }
    var trigger = document.createElement('button');
    trigger.type = 'button'; trigger.className = 'native-size-trigger'; trigger.textContent = 'Size Chart'; trigger.setAttribute('aria-haspopup','dialog');
    row.querySelector('.product-size-links').appendChild(trigger);
    var dialog = root.querySelector('dialog'), tabs = root.querySelector('[data-size-tabs]'), panels = root.querySelector('[data-size-panels]');
    var tabButtons = [], tabPanels = [];
    function activate(index, focus) {
      tabButtons.forEach(function (button, i) { button.setAttribute('aria-selected',String(i === index)); button.tabIndex = i === index ? 0 : -1; tabPanels[i].hidden = i !== index; });
      if (focus) tabButtons[index].focus();
    }
    charts.forEach(function (chart, index) {
      var button = document.createElement('button'), panel = document.createElement('div');
      var id = 'size-chart-' + section.id + '-' + index;
      button.type = 'button'; button.role = 'tab'; button.id = id + '-tab'; button.textContent = chart.title;
      button.setAttribute('aria-controls',id); panel.id = id; panel.role = 'tabpanel'; panel.setAttribute('aria-labelledby',button.id);
      button.addEventListener('click',function () { activate(index); });
      button.addEventListener('keydown',function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % charts.length;
        if (event.key === 'ArrowLeft') next = (index + charts.length - 1) % charts.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = charts.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(next,true); }
      });
      var caption = document.createElement('p'); caption.textContent = chart.title + (chart.units ? ' — ' + chart.units : ''); panel.appendChild(caption);
      if (chart.instructions) { var instructions = document.createElement('p'); instructions.textContent = chart.instructions; panel.appendChild(instructions); }
      var wrap = document.createElement('div'); wrap.className = 'native-size-table'; wrap.tabIndex = 0; wrap.setAttribute('role','region'); wrap.setAttribute('aria-label',chart.title + ' measurements');
      var table = document.createElement('table'), head = document.createElement('thead'), body = document.createElement('tbody');
      parseTable(chart.measurements).forEach(function (cells,i) {
        var tr = document.createElement('tr');
        cells.forEach(function (value,j) { var cell = document.createElement(!i || !j ? 'th' : 'td'); if (!i || !j) cell.scope = !i ? 'col' : 'row'; cell.textContent = value; tr.appendChild(cell); });
        (i ? body : head).appendChild(tr);
      }); table.append(head,body); wrap.appendChild(table); panel.appendChild(wrap);
      if (chart.notes) { var notes = document.createElement('p'); notes.textContent = chart.notes; panel.appendChild(notes); }
      tabs.appendChild(button); panels.appendChild(panel); tabButtons.push(button); tabPanels.push(panel);
    });
    tabs.hidden = charts.length === 1;
    function currentIndex() {
      if (styleIndex < 0 || config.override) return 0;
      var field = selectors.querySelector('[data-index="option' + (styleIndex + 1) + '"]:checked') || selectors.querySelector('select[data-index="option' + (styleIndex + 1) + '"]');
      var current = normalize(field ? field.value : config.initial[styleIndex]);
      return charts.findIndex(function (chart) { return aliases(chart.styles).includes(current); });
    }
    function sync() {
      var index = currentIndex(), supported = index >= 0;
      selectors.classList.toggle('native-size-active',supported); trigger.hidden = !supported; root.hidden = !supported;
      if (supported) activate(index); else if (dialog.open) dialog.close();
    }
    trigger.addEventListener('click',function () { sync(); dialog.showModal(); });
    root.querySelector('[data-size-close]').addEventListener('click',function () { dialog.close(); });
    dialog.addEventListener('click',function (event) { if (event.target === dialog) { var rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    selectors.addEventListener('change',sync);
    sync();
  }
  document.querySelectorAll('[data-native-size-guide]').forEach(init);
  document.addEventListener('shopify:section:load',function (event) { event.target.querySelectorAll('[data-native-size-guide]').forEach(init); });
}());
